export const DEFAULT_ERRORS = {}
export const DEFAULT_MODAL_OPEN = false
export const DEFAULT_SUBMITTING = false
export const DEFAULT_SLIDE_IN_ENABLED = true
export const DEFAULT_SLIDE_IN_PAUSED = false

export const DEFAULT_SEARCH_JOBMAIL_STATE = { open: false, overlay: false, dueToScroll: false, visible: true }

export default {
  errors: DEFAULT_ERRORS,
  searchJobmailState: DEFAULT_SEARCH_JOBMAIL_STATE,
  submitting: DEFAULT_SUBMITTING,
  slideInEnabled: DEFAULT_SLIDE_IN_ENABLED,
  slideInPaused: DEFAULT_SLIDE_IN_PAUSED,
  modalOpen: DEFAULT_MODAL_OPEN
}
